'use client';

import Box from '@mui/material/Box';
import { Children } from 'react';

// Literales hex: los tokens de MUI fallan dentro de shorthands de border responsivos.
export const BORDER_CREAM = '#d8cdb8';
export const BORDER_NAVY = 'rgba(194,161,92,0.18)';

/**
 * Grid con separadores automáticos entre celdas (líneas de 1px).
 *
 * @param {number}  cols   columnas en md+ (xs siempre 2, salvo colsXs)
 * @param {number}  colsXs columnas en xs (default 2)
 * @param {'cream'|'navy'} tone  color de las líneas
 * @param {object}  itemSx sx extra por celda (ej. padding)
 */
export default function DividedGrid({
  cols = 3,
  colsXs = 2,
  tone = 'cream',
  children,
  itemSx = {},
  sx = {},
  ...props
}) {
  const color = tone === 'navy' ? BORDER_NAVY : BORDER_CREAM;
  const items = Children.toArray(children);
  const n = items.length;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: `repeat(${colsXs}, 1fr)`,
          md: `repeat(${cols}, 1fr)`,
        },
        border: `1px solid ${color}`,
        ...sx,
      }}
      {...props}
    >
      {items.map((child, i) => (
        <Box
          key={i}
          sx={{
            // Borde derecho salvo en la última columna. En la última fila
            // incompleta, la última celda real sí lo lleva (divide del hueco).
            borderRight: {
              xs: (i + 1) % colsXs !== 0 ? `1px solid ${color}` : 'none',
              md: (i + 1) % cols !== 0 ? `1px solid ${color}` : 'none',
            },
            borderBottom: {
              xs:
                i < n - (n % colsXs || colsXs) ? `1px solid ${color}` : 'none',
              md: i < n - (n % cols || cols) ? `1px solid ${color}` : 'none',
            },
            ...itemSx,
          }}
        >
          {child}
        </Box>
      ))}
    </Box>
  );
}
